module.exports = __webpack_public_path__ + "img/section4_3.de317ca0.png";